// extracted by mini-css-extract-plugin
export default {"middle-ellipsis-label":"MiddleEllipsisLabel_middle-ellipsis-label__+43Zr","head":"MiddleEllipsisLabel_head__pe0Em","tail":"MiddleEllipsisLabel_tail__oh1OY"};